import {  ISmsRepository } from './ISmsRepository';
import type BaseApiProvider from 'providers/BaseApiProvider';
import { injectable, inject } from 'inversify';
import { ApiResponseModel } from 'models/ApiResponseModel';
import Logger from 'utilities/log';
import { PaginationModel } from 'models/PaginationModel';
import { SmsLogGetPayloadModel, SmsLogModel, SmsLogPayloadModel } from 'models/sms/SMSModel';

@injectable()
class SmsRepository implements ISmsRepository {

       @inject(Symbol.for("BaseApiProvider_5080")) private _provider?: BaseApiProvider;


    public async SaveSendSmsLogInfo(params: SmsLogPayloadModel): Promise<ApiResponseModel | null> {
        try {
            const url = `Api/SmsAction/SaveSendSmsLogInfo`;
            const response = await this._provider!.post(url, params);
            const res = ApiResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to SetSmsLog: ${error}`);
            throw new Error(`Failed to SetSmsLog: ${error}`);
        }
    }

    public async DeleteSendSmsLogInfo(Id: number): Promise<ApiResponseModel | null> {
        try {
            const url = `Api/SmsAction/DeleteSendSmsLogInfo`;
            const formData = new FormData();
            formData.append('UserSmsLogId', Id.toString());
            const response = await this._provider!.postForm(url, formData);
            const res = ApiResponseModel.fromJson(response);
            res.data = response["data"];
            return res;
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to DeleteSmsLog: ${error}`);
            throw new Error(`Failed to DeleteSmsLog: ${error}`);
        }
    }

    

    public async GetAllSendSmsLogInfo(params: SmsLogGetPayloadModel): Promise<{
        rows: SmsLogModel[];
        pagination: PaginationModel;
    } | null> {
        try {
            const url = `Api/SmsInfo/GetAllSendSmsLogInfo`;
            const response = await this._provider!.post(url, params);
            const res = ApiResponseModel.fromJson(response);

            if (!res.status) {
                Logger.event('API_RESPONSE_ERROR', res.error || 'Failed to get smslogs list');
                return null;
            }

            return {
                rows: response["data"]["rows"].map((js: any) => SmsLogModel.fromJson(js)),
                pagination: PaginationModel.fromJson(response["data"])
            };
        } catch (error) {
            Logger.event('API_RESPONSE_ERROR', `Failed to get smslogs list: ${error}`);
            throw new Error(`Failed to get smslogs list: ${error}`);
        }
    }
    public async GetSendSmsLogInfo(params: SmsLogGetPayloadModel): Promise<SmsLogModel| null> {
        try {
            const url = `Api/SmsInfo/GetSendSmsLogInfo`;
            const response = await this._provider!.post(url, params);
            const res = ApiResponseModel.fromJson(response);

            if (!res.status) {
                Logger.event('API_RESPONSE_ERROR', res.error || 'Failed to get smslog info');
                return null;
            }
            return SmsLogModel.fromJson(response["data"]);

        } catch (error) {
            if (error instanceof Error) {
                Logger.event('API_RESPONSE_ERROR', `Api failed: ${error.message}`);
                throw new Error(`Api failed: ${error.message}`);
            } else {
                Logger.event('API_RESPONSE_ERROR', 'Api failed: Unknown error');
                throw new Error('Api failed: Unknown error');
            }
        }
    }


}

export default SmsRepository;;
